/**
 * Theme-Konstanten – bewusst OHNE "use client".
 *
 * Wichtig: `themeInitScript` wird vom Root-Layout (Server Component) gerendert.
 * Läge die Konstante in einer "use client"-Datei, würde Next.js daraus eine
 * Client-Referenz machen statt eines Strings – das Skript landete dann nie im HTML.
 */

export type Theme = "light" | "dark";

export const THEME_STORAGE_KEY = "wedev-theme";

/**
 * Inline-Skript, das VOR dem ersten Paint läuft und `data-theme` setzt.
 * Ohne dieses Skript blitzt die Seite kurz im Standard-Theme auf, bevor
 * React die gespeicherte Wahl anwendet (FOUC).
 *
 * Reihenfolge: gespeicherte Wahl → Systemeinstellung → hell.
 */
export const themeInitScript = `(function(){try{var s=localStorage.getItem(${JSON.stringify(
  THEME_STORAGE_KEY,
)});var t=(s==="dark"||s==="light")?s:(window.matchMedia("(prefers-color-scheme: dark)").matches?"dark":"light");document.documentElement.setAttribute("data-theme",t);}catch(e){document.documentElement.setAttribute("data-theme","light");}})();`;
